/**
 * Product panel chrome — edit panel, preview-3d / shipping text,
 * PDP show/hide, mockup preview / size mockups / variant picker / errors.
 * Orchestrator calls window.CustomProductPanelUI (process stays chrome-free).
 */
(() => {
  'use strict';

  const SELECTORS = {
    productPanel: '.product-panel',
    editPanel: '[data-panel-id]',
    productPanelInfo: '[data-info-panel]',
    editBlock: '[data-edit-block]',
    editBlockByAction: (action) => `[data-edit-block="${action}"]`,
    editBlockElement: '.edit-block',
    editOptionWrap: '.edit-option__wrap',
    editAction: '[data-edit-action]',
    editPanelOptions: '[data-edit-panel="options"]'
  };

  const DATA_ATTRS = {
    togglePanel: 'toggle-panel',
    closePanel: 'close-panel',
    editAction: 'edit-action',
    panelId: 'panel-id',
    infoPanel: 'info-panel',
    editBlock: 'edit-block',
    editPanel: 'edit-panel'
  };

  const CLASSES = {
    hide: 'hide',
    active: 'active'
  };

  const ACTIONS = {
    close: 'close',
    options: 'options'
  };

  const getPanelElements = ($trigger) => {
    const $productPanel = $trigger.closest(SELECTORS.productPanel);
    return {
      $productPanel,
      $editPanel: $productPanel.find(SELECTORS.editPanel).first(),
      $productPanelInfo: $productPanel.find(SELECTORS.productPanelInfo).first()
    };
  };

  const resetEditUI = ($editPanel) => {
    $editPanel.find(SELECTORS.editBlock).addClass(CLASSES.hide);
    $editPanel.find(`${SELECTORS.editOptionWrap} ${SELECTORS.editAction}`).removeClass(CLASSES.active);
    $editPanel.find(SELECTORS.editPanelOptions).removeClass(CLASSES.hide);
  };

  const showEditPanel = ($editPanel, $productPanelInfo) => {
    $editPanel.removeClass(CLASSES.hide).css('display', '');
    $productPanelInfo.addClass(CLASSES.hide);
  };

  const hideEditPanel = ($editPanel, $productPanelInfo) => {
    $editPanel.addClass(CLASSES.hide);
    $productPanelInfo.removeClass(CLASSES.hide).css('display', '');
  };

  // Open edit panel
  $(document).on('click', `button[data-${DATA_ATTRS.togglePanel}]`, function (e) {
    e.preventDefault();
    const { $editPanel, $productPanelInfo } = getPanelElements($(this));
    if ($editPanel.length && $productPanelInfo.length) {
      showEditPanel($editPanel, $productPanelInfo);
    }
  });

  // Close edit panel and reset UI
  $(document).on('click', `button[data-${DATA_ATTRS.closePanel}]`, function (e) {
    e.preventDefault();
    const { $editPanel, $productPanelInfo } = getPanelElements($(this));
    if ($editPanel.length && $productPanelInfo.length) {
      resetEditUI($editPanel);
      hideEditPanel($editPanel, $productPanelInfo);
    }
  });

  // Active state for buttons inside [data-edit-panel]
  $(document).on('click', '[data-edit-panel] > button, [data-edit-panel] button', function () {
    const $button = $(this);
    const $editPanelContainer = $button.closest('[data-edit-panel]');
    if ($editPanelContainer.length) {
      $editPanelContainer.find('button').removeClass(CLASSES.active);
      $button.addClass(CLASSES.active);
    }
  });

  // Open / close specific edit blocks
  $(document).on('click', SELECTORS.editAction, function (e) {
    e.preventDefault();
    const action = String($(this).data(DATA_ATTRS.editAction) || '').trim();
    if (!action) return;

    const $button = $(this);
    const $productPanel = $button.closest(SELECTORS.productPanel);
    if (!$productPanel.length) return;

    const $editWrap = $button.closest(SELECTORS.editOptionWrap);
    let $panel = null;

    if ($editWrap.length) {
      $panel = $editWrap.closest(SELECTORS.editPanel);
    }

    if (!$panel || !$panel.length) {
      $panel = $button.closest(SELECTORS.editPanel);
      if (!$panel.length) {
        $panel = $productPanel.find(SELECTORS.editPanel).first();
      }
    }

    if (!$panel || !$panel.length) return;

    if ($panel.hasClass(CLASSES.hide)) {
      const $productPanelInfo = $productPanel.find(SELECTORS.productPanelInfo).first();
      if ($productPanelInfo.length) {
        showEditPanel($panel, $productPanelInfo);
      }
    }

    const $optionsPanel = $panel.find(SELECTORS.editPanelOptions);

    if (action === ACTIONS.close) {
      const $editBlock = $button.closest(SELECTORS.editBlockElement);
      if ($editBlock.length) {
        $editBlock.addClass(CLASSES.hide);
      } else {
        $panel.find(SELECTORS.editBlock).addClass(CLASSES.hide);
      }
      if ($editWrap.length) {
        $editWrap.find(SELECTORS.editAction).removeClass(CLASSES.active);
      } else {
        $panel.find(SELECTORS.editOptionWrap).find(SELECTORS.editAction).removeClass(CLASSES.active);
      }
      $optionsPanel.removeClass(CLASSES.hide);
      return;
    }

    $optionsPanel.addClass(CLASSES.hide);
    $panel.find(SELECTORS.editBlock).addClass(CLASSES.hide);
    $panel.find(SELECTORS.editBlockByAction(action)).removeClass(CLASSES.hide);

    if ($editWrap.length) {
      $editWrap.find(SELECTORS.editAction).removeClass(CLASSES.active);
    } else {
      $panel.find(SELECTORS.editOptionWrap).find(SELECTORS.editAction).removeClass(CLASSES.active);
    }
    $button.addClass(CLASSES.active);
  });

  $(document).on('click', '[data-action="hide-edit-panels"]', function (e) {
    e.preventDefault();

    const $productPanel = $(SELECTORS.productPanel).first();
    const $editPanel = $productPanel.find(SELECTORS.editPanel).first();
    const $productPanelInfo = $productPanel.find(SELECTORS.productPanelInfo).first();

    if ($editPanel.length && $productPanelInfo.length) {
      resetEditUI($editPanel);
      hideEditPanel($editPanel, $productPanelInfo);
    }
  });

  // Preview 3D button on size/variant label click
  $(document).on('click', '[data-form-variant-label]', () => {
    $('[data-preview-3d-button]').removeClass(CLASSES.hide);
  });

  // Shipping banner — sizeKey from form propChange (not DOM scrape)
  $(document).on('productFormCustom:propChange', (e) => {
    const detail = e.originalEvent?.detail || e.detail || {};
    if (detail.prop !== 'size') return;
    const sizeValue = String(detail.sizeKey || detail.value || '').trim().toLowerCase();
    const $defaultText = $('[data-text="default"]');
    const $xLargeText = $('[data-text="x-large"]');
    if (sizeValue === 'x-large') {
      $defaultText.addClass(CLASSES.hide);
      $xLargeText.removeClass(CLASSES.hide);
    } else {
      $defaultText.removeClass(CLASSES.hide);
      $xLargeText.addClass(CLASSES.hide);
    }
  });

  // ---------------------------------------------------------------------------
  // PDP chrome API (orchestrator → signals only)
  // ---------------------------------------------------------------------------
  const VARIANT_PICKER = '[data-variant-picker-custom]';

  const getFormId = () => (
    window.CustomProductOrchestrator?.getConfig?.()?.formId || 'product-panel-form'
  );

  $(document).on('click', '[data-action="show-product-block"]', function (e) {
    e.preventDefault();
    showProductBlock();
  });

  $(document).on('click', '[data-action="hide-product-block"]', function () {
    window.CustomProductOrchestrator?.initialState?.();
  });

  const getSectionsToHide = () => {
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index';
    if (!isHomePage) return $();
    const $mainContent = $('#MainContent');
    if (!$mainContent.length) return $();
    const $allSections = $mainContent.find('.shopify-section');
    if (!$allSections.length) return $();
    const sectionNames = ['brand_logos', 'multicolumn_cards'];
    return $allSections.filter(function () {
      const sectionId = $(this).attr('id') || '';
      return sectionNames.some((name) => sectionId.includes(name));
    });
  };

  const hideEditButtonsPanel = () => {
    $('[data-edit-buttons-panel]').stop(true, true).hide();
  };

  const onPreviewReady = () => {
    const $editButtonsPanel = $('[data-edit-buttons-panel]');
    if ($editButtonsPanel.length && $editButtonsPanel.css('display') === 'none') {
      setTimeout(() => {
        $editButtonsPanel.slideDown(300);
      }, 2000);
    }
  };

  const showVariantPicker = () => {
    const formId = getFormId();
    if (formId) $(`#${formId}`).slideDown();
  };

  const isTowelProduct = () => (
    window.CustomProductOrchestrator?.getConfig?.()?.productType === 'towel'
  );

  const updatePreview = (preview) => {
    if (!preview) return;
    window.SizeMockups?.generateAndShow?.(preview);
    // Towel Type cards (Full / Object / Pattern) each need their own thumb
    // from the print-type script — stamping one mockup on every card (and
    // hiding all preloaders) is wrong. Same skip as legacy
    // section-main-shaped-towel.js UIService.updatePreview.
    if (!isTowelProduct()) {
      window.VariantPickerCustom?.setImages?.(preview, VARIANT_PICKER);
    }
    showVariantPicker();
    onPreviewReady();
  };

  const clearPreview = () => {
    // Towel owns Type-card images via generateAllPreviews — orch reset must
    // not wipe them (processInit runs after Full thumb often already landed).
    if (!isTowelProduct()) {
      window.VariantPickerCustom?.clearImages?.(VARIANT_PICKER);
    }
    window.SizeMockups?.hideWidget?.();
  };

  const clearSizeMockups = () => {
    window.SizeMockups?.clear?.();
  };

  const hideSizeMockupsWidget = () => {
    window.SizeMockups?.hideWidget?.();
  };

  const clearVariantPicker = () => {
    if (isTowelProduct()) return;
    window.VariantPickerCustom?.clearImages?.(VARIANT_PICKER);
  };

  /** Size prop changed — show matching size mockup for current preview. */
  const applySizePreview = (sizeKey, preview) => {
    if (!sizeKey || !preview) return;
    window.VariantPickerCustom?.setImages?.(preview, VARIANT_PICKER);

    const key = String(sizeKey).trim();
    const showSize = (k) => (
      window.SizeMockups?.showSizeByKey?.(k)
      || window.SizeMockups?.showSizeByKey?.(k.toLowerCase())
      || false
    );
    if (showSize(key)) return;

    window.SizeMockups?.generateAndShow?.(preview);
    $(document).one(
      window.SizeMockups?.events?.generated || 'sizeMockups:generated',
      () => { showSize(key); }
    );
  };

  const mapErrorType = (errorType) => {
    const rawType = String(errorType || '').toLowerCase();
    if (rawType.includes('removebg')) return 'removebg';
    if (rawType.includes('network') || rawType.includes('save') || rawType.includes('s3')) {
      return 'network';
    }
    if (rawType.includes('pillow') || rawType.includes('mockup')) return 'mockup';
    return 'unknown';
  };

  const showError = (type) => {
    window.MockupErrorBlock?.show?.({ type });
  };

  const hideError = () => {
    window.MockupErrorBlock?.hide?.();
  };

  const showProductBlock = () => {
    $('[product-block]').removeClass(CLASSES.hide).css('display', '');
    $('[data-block-id="product-panel"]').removeClass(CLASSES.hide).css('display', '');
    $('[data-block-id="product-info"]').addClass(CLASSES.hide);
    $('.js-hidden-mockup').removeClass(CLASSES.hide);
    // Shaped uses data-hide-on-upload; towel sections use class js-hide-on-upload
    $('[data-hide-on-upload], .js-hide-on-upload').addClass(CLASSES.hide);
    $('[data-main-product-preloader]').addClass(CLASSES.hide);

    getSectionsToHide().addClass(CLASSES.hide).css('display', 'none');
    $('[data-hide-on-product-panel]').addClass(CLASSES.hide);
    $('.c-post__btn').addClass(CLASSES.hide);

    $('html, body').animate({ scrollTop: 74 }, 300);
  };

  const hideProductBlock = () => {
    $('[product-block]').addClass(CLASSES.hide);
    $('[data-block-id="product-panel"]').addClass(CLASSES.hide);
    $('[data-block-id="product-info"]').removeClass(CLASSES.hide);
    $('.js-hidden-mockup').addClass(CLASSES.hide);
    $('[data-hide-on-upload], .js-hide-on-upload').removeClass(CLASSES.hide).css('display', '');
    $('[data-hide-on-product-panel]').removeClass(CLASSES.hide).css('display', '');
    hideEditButtonsPanel();

    const $mainContent = $('#MainContent');
    if ($mainContent.length) {
      $mainContent.find('.shopify-section.hide').removeClass(CLASSES.hide).css('display', '');
      $('.c-post__btn').removeClass(CLASSES.hide);
    }
  };

  const reset = () => {
    clearSizeMockups();
    hideSizeMockupsWidget();
    clearVariantPicker();
    showProductBlock();
  };

  window.CustomProductPanelUI = {
    showProductBlock,
    hideProductBlock,
    onPreviewReady,
    hideEditButtonsPanel,
    updatePreview,
    clearPreview,
    reset,
    applySizePreview,
    showError,
    hideError,
    mapErrorType,
    showVariantPicker,
    clearSizeMockups,
    hideSizeMockupsWidget,
    clearVariantPicker
  };
})();
